import React from "react";
import { Card, Table } from "react-bootstrap";
import { FieldArray, useFormikContext } from "formik";
import Swal from "sweetalert2";
import _ from "lodash";
import { amountByPercent } from "../../../../../utils/utils";
import NumberFormat from "react-number-format";
import { useState } from "react";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions, InputAdornment, Typography } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import {
  FormArraySelectField,
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import SearchWarehouse from "../../../inventory/warehouses/searchWarehouse";
import SearchOutletStocks from "../../outlets/outletDetail/searchOutletStocks";
import Illustration from "../../../../../partials/content/Illustration";
import SearchDeliveredItem from "../../../inventory/stock-management/delivery/searchDeliveredItem";
function SalesReturnItem(props) {
  const { values, setFieldValue } = useFormikContext();
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [openOutletStock, setOpenOutletStock] = useState(false);
  const [openDeliveredItems, setOpenDeliveredItems] = useState(false);
  const { salesOrder } = values;
  const handleCalculateSalesReturn = (
    index = 0,
    salesItemID = 0,
    qtyReturn = 0
  ) => {
    const salesReturnItems = [...values.salesReturnItems];
    qtyReturn = parseFloat(qtyReturn);
    let discountAmount = 0;
    let discountPercent = 0;
    let taxAmount = 0;
    let taxPercent = 0;
    let totalPrice = 0;
    let subTotal = 0;
    let total = 0;
    for (const salesItem of values.salesItems) {
      discountAmount = 0;
      discountPercent = 0;
      taxAmount = 0;
      taxPercent = 0;
      if (salesItem.ID === salesItemID) {
        totalPrice = qtyReturn * salesItem.unitPrice;
        discountAmount = amountByPercent(salesItem.discountPercent, totalPrice);
        totalPrice -= discountAmount;
        discountPercent = salesItem.discountPercent;
        break;
      }
    }
    salesReturnItems[index].totalPrice = totalPrice;

    for (const salesReturnItem of salesReturnItems) {
      subTotal += salesReturnItem.totalPrice;
    }
    total = subTotal;
    setFieldValue("salesReturnItems", salesReturnItems);
    setFieldValue("subTotalRet", subTotal);

    discountAmount = amountByPercent(salesOrder.discountPercent, subTotal);
    total -= discountAmount;
    discountPercent = salesOrder.discountPercent;

    setFieldValue("taxName", salesOrder.taxName);
    taxAmount = amountByPercent(salesOrder.taxPercent, subTotal);
    total += taxAmount;
    taxPercent = salesOrder.taxPercent;

    setFieldValue("exchangeRate", salesOrder.excnageRate);
    setFieldValue("discountAmount", discountAmount);
    setFieldValue("discountPercent", discountPercent);
    setFieldValue("taxAmount", taxAmount);
    setFieldValue("taxPercent", taxPercent);
    setFieldValue("grandTotalRet", total);
  };
  return (
    <React.Fragment>
      <FieldArray name="salesReturnItems">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.salesReturnItems &&
                    values.salesReturnItems.length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <React.Fragment>
                            {!values.soLock ? (
                              <React.Fragment>
                                <th style={{ width: "25%" }}>Item Name</th>
                                <th style={{ width: "10%" }}>
                                  Delivered Quantity
                                </th>
                                <th style={{ width: "10%" }}>
                                  Returned Quantity
                                </th>
                                <th style={{ width: "10%" }}>Unit</th>
                                <th style={{ width: "10%" }}>Batch ID</th>
                                <th style={{ width: "15%" }}>Reason</th>
                                {values.processType === 1 ? (
                                  <th style={{ width: "15%" }}>
                                    Returned Stock
                                  </th>
                                ) : (
                                  <th style={{ width: "15%" }}>
                                    Returned Amount
                                  </th>
                                )}
                              </React.Fragment>
                            ) : values.processType === 2 ? (
                              <React.Fragment>
                                <th style={{ width: "25%" }}>Item Name</th>
                                <th style={{ width: "10%" }}>
                                  Delivered Quantity
                                </th>
                                <th style={{ width: "10%" }}>
                                  Returned Quantity
                                </th>
                                <th style={{ width: "10%" }}>Unit</th>
                                <th style={{ width: "10%" }}>Batch ID</th>
                                <th style={{ width: "15%" }}>Reason</th>
                                <th style={{ width: "15%" }}>
                                  Returned Amount
                                </th>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <th style={{ width: "35%" }}>Item Name</th>
                                <th style={{ width: "10%" }}>
                                  Delivered Quantity
                                </th>
                                <th style={{ width: "10%" }}>
                                  Returned Quantity
                                </th>
                                <th style={{ width: "10%" }}>Unit</th>
                                <th style={{ width: "10%" }}>Batch ID</th>
                                <th style={{ width: "20%" }}>Reason</th>
                              </React.Fragment>
                            )}
                          </React.Fragment>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.salesReturnItems &&
                      values.salesReturnItems.length > 0 ? (
                        values.salesReturnItems.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <FormOutlinedNoMarginTextField
                                  value={`${item.itemCode} ${item.itemName}`}
                                  InputProps={{
                                    startAdornment:
                                      item.itemType > 0 ? (
                                        <InputAdornment position="start">
                                          <BootstrapTooltip
                                            title={item.itemTypeName}
                                          >
                                            <i
                                              className={
                                                item.itemType === 1
                                                  ? "fas fa-boxes text-success"
                                                  : item.itemType === 2
                                                  ? "fas fa-tools text-primary"
                                                  : item.itemType === 3
                                                  ? "fas fa-building text-info"
                                                  : item.itemType === 4
                                                  ? "fas fa-boxes text-warning"
                                                  : item.itemType === 5
                                                  ? "fas fa-boxes text-danger"
                                                  : null
                                              }
                                            ></i>
                                          </BootstrapTooltip>
                                        </InputAdornment>
                                      ) : null,
                                    readOnly: true,
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="salesReturnItems"
                                  index={index}
                                  propName="qtyDelivered"
                                  quantityField
                                  margin="none"
                                  readonly
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="salesReturnItems"
                                  index={index}
                                  propName="qtyReturn"
                                  quantityField
                                  margin="none"
                                  onBlur={(value) => {
                                    handleCalculateSalesReturn(
                                      index,
                                      item.salesPosItemID > 0
                                        ? item.salesPosItemID
                                        : item.salesOrderItemID > 0
                                        ? item.salesOrderItemID
                                        : 0,
                                      value
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="salesReturnItems"
                                  index={index}
                                  propName="uomName"
                                  margin="none"
                                  readonly
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="salesReturnItems"
                                  index={index}
                                  propName="batchID"
                                  margin="none"
                                  readonly
                                />
                              </td>
                              <td>
                                <FormArraySelectField
                                  arrayPropName="salesReturnItems"
                                  propName="reasonID"
                                  index={index}
                                  margin="none"
                                  options={[
                                    { label: "Lost", value: 1 },
                                    { label: "Damaged", value: 2 },
                                    { label: "Expired", value: 3 },
                                    { label: "Wrong Item", value: 4 },
                                  ]}
                                />
                              </td>
                              <React.Fragment>
                                {!values.soLock ? (
                                  <React.Fragment>
                                    {values.processType === 1 ? (
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="salesReturnItems"
                                          index={index}
                                          propName="pickBatchID"
                                          margin="none"
                                          searchButton
                                          onSearchClick={() => {
                                            setItemIndex(index);
                                            setOpenOutletStock(true);
                                          }}
                                          readonly
                                        />
                                      </td>
                                    ) : (
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="salesReturnItems"
                                          index={index}
                                          propName="totalPrice"
                                          margin="none"
                                          currencyField
                                          currencyCode={values.currencyCode}
                                          readonly
                                        />
                                      </td>
                                    )}
                                  </React.Fragment>
                                ) : values.processType === 2 ? (
                                  <td>
                                    <FormArrayTextField
                                      arrayPropName="salesReturnItems"
                                      index={index}
                                      propName="totalPrice"
                                      margin="none"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                      readonly
                                    />
                                  </td>
                                ) : null}
                              </React.Fragment>

                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                <BootstrapTooltip title="Delete Sales Return">
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                    onClick={() => {
                                      remove(index);
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                </BootstrapTooltip>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            className="text-center py-3"
                            colSpan={`${
                              !values.soLock
                                ? "8"
                                : values.processType === 2
                                ? "8"
                                : "7"
                            }`}
                          >
                            <Illustration
                              imageSource="INVIFO Sales.png"
                              guidance="You don't have any Sales Return items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td
                          className="text-center py-3"
                          colSpan={`${
                            !values.soLock
                              ? "8"
                              : values.processType === 2
                              ? "8"
                              : "7"
                          }`}
                        >
                          <button
                            type="button"
                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                            onClick={() => {
                              setOpenDeliveredItems(true);
                            }}
                          >
                            <i className="fas fa-plus-circle"></i>
                            Add Sales Return Item
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            {values.processType === 2 ? (
              <div className="row mt-3">
                <div className="col-sm-12 col-md-6 col-lg-6"></div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <Card>
                    <Card.Body className="pb-0">
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr className="border-bottom">
                            <td style={{ width: "50%" }}>
                              <Typography className="mb-3 kt-font-bolder">
                                Sub Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                component="div"
                                className="mb-3 kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.subTotalRet}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.discountPercent}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div>
                                      Discount{" ("}
                                      {value}
                                      {"%)"}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.discountAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      - {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.taxPercent}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div>
                                      Tax{" ("}
                                      {value}
                                      {"%)"}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.taxAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                className="kt-font-bolder"
                              >
                                Grand Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.grandTotalRet}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
              </div>
            ) : null}
            <DialogLayout
              open={openDeliveredItems}
              title="Search Sales Order Delivered Items"
              onCloseDialog={() => {
                setOpenDeliveredItems(false);
              }}
              maxWIdth="lg"
            >
              <SearchDeliveredItem
                salesOrderID={values.salesOrderID}
                onSelectDeliveredItem={(deliveredItem) => {
                  const deliveryValue = _.find(values.salesReturnItems, [
                    "deliveryItemID",
                    deliveredItem.deliveryItemID,
                  ]);
                  if (deliveryValue && deliveryValue.deliveryItemID > 0) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Failed",
                      text: `Delivered item cannot be added twice in the same Sales Return`,
                      icon: "error",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  } else {
                    push({
                      deliveryItemID: deliveredItem.deliveryItemID,
                      salesOrderItemID: deliveredItem.salesOrderItemID,
                      salesPosItemID: deliveredItem.salesPosItemID,
                      itemID: deliveredItem.itemID,
                      itemType: deliveredItem.itemType,
                      itemTypeName: deliveredItem.itemTypeName,
                      itemCode: deliveredItem.itemCode,
                      itemName: deliveredItem.itemName,
                      varCode: deliveredItem.varCode,
                      qtyDelivered: deliveredItem.qty,
                      qtyReturn: 0,
                      batchID: deliveredItem.batchID,
                      uomID: deliveredItem.uomID,
                      uomName: deliveredItem.uomName,
                      reasonID: 1,
                      pickbatchID: 0,
                      totalPrice: 0,
                    });
                    setOpenDeliveredItems(false);
                  }
                }}
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenDeliveredItems(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchWarehouse}
        title="Search Warehouse"
        onCloseDialog={() => {
          setOpenSearchWarehouse(false);
        }}
        maxWIdth="md"
      >
        <SearchWarehouse
          onSelectWarehouse={(warehouse) => {
            setFieldValue(
              `salesReturnItems[${itemIndex}].reqWarehouseID`,
              warehouse.ID
            );
            setFieldValue(
              `salesReturnItems[${itemIndex}].reqWarehouseName`,
              warehouse.warehouseName
            );
            setOpenSearchWarehouse(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchWarehouse(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openOutletStock}
        title="Search Outlet Stock"
        onCloseDialog={() => {
          setOpenOutletStock(false);
        }}
        maxWIdth="lg"
      >
        {values.salesReturnItems[itemIndex] ? (
          <SearchOutletStocks
            outletID={values.outletID}
            itemID={values.salesReturnItems[itemIndex].itemID}
            varCode={values.salesReturnItems[itemIndex].varCode}
            onSelectStock={(stock) => {
              setFieldValue(
                `salesReturnItems[${itemIndex}].pickBatchID`,
                stock.batchID
              );
              setOpenOutletStock(false);
            }}
          />
        ) : null}

        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenOutletStock(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default SalesReturnItem;
